<template>
  <v-dialog v-model="delDialog" persistent max-width="350">
    <v-card class="dialog-cls">
      <v-card-title>
        <span class="dialog-title">Delete Request</span>
      </v-card-title>
      <v-card-text class="dialog-text">
        Are you sure you want to
        <strong color="red darken-1">Delete</strong> record ?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="disAgree">Disagree</v-btn>
        <v-btn color="green darken-1" text @click="agree">Agree</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { NewsFeedService } from "@/services";
import { mapGetters } from "vuex";

export default {
  name: "DeleteItem",
  props: {
    commentId: String,
    module: String,
    size: String,
    comment: Object,
    delDialog: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("newsFeedsComment", {
      newsFeedId: "newsFeedId"
    })
  },
  methods: {
    async agree() {
      this.$emit("closeDialog", false);
      const response = await NewsFeedService.deleteRequest({
        path: "newsFeed/comment/delete/",
        id: this.commentId
      });
      if (response) {
        this.$store.dispatch("user/setSnack", response.data.msg);
        this.$store.dispatch("user/setType", "info");
        this.$emit("deleteRequest", this.commentId);
        let params = {
          newsFeedId: this.newsFeedId
        };

        //this.$store.dispatch('newsFeedsComment/getComments',params);
        if (this.comment.parentId) {
          params.parentId = this.comment.parentId;
          this.$parent.$parent.$parent.$parent.$parent.getComments();
        } else {
          this.$parent.$parent.$parent.$parent.getComments();
        }
        params.id = this.commentId;
        this.$parent.$parent.updateDeleted(params);
      }
    },
    disAgree() {
      this.$emit("closeDialog", false);
    }
  }
};
</script>
